import { useLocale } from "next-intl";
import { useQuery } from "@tanstack/react-query";

import { getSportsSuspensions } from "@/api/sportsNew";
import { SportsNewQueryKeys } from "./sportsNewQueryKeys";

export const useSportsSuspensions = (targetUsername?: string) => {
  const lang = useLocale();

  return useQuery({
    queryKey: [SportsNewQueryKeys.SportsSuspensions, targetUsername],
    queryFn: ({ signal }) =>
      getSportsSuspensions({ signal, params: { lang, targetUsername } }),
  });
};
